import styles from './DashboardHeader.module.scss'
import { Grid } from 'semantic-ui-react'
import styled from 'styled-components'

interface DashboardHeaderProps {
  logo: string | null
  headline: string | null
  content: string | null
}

export const DashboardHeader = ({
  logo,
  headline,
  content
}: DashboardHeaderProps): JSX.Element => (
  <div className={styles.introCard + ' buildingBlock'}>
    <Grid container verticalAlign="middle">
      {logo && (
        <Grid.Column className={styles.logoColumn} mobile={16} computer={4}>
          <Logo src={logo} />
        </Grid.Column>
      )}
      <Grid.Column mobile={16} computer={12} style={{ whiteSpace: 'pre-line' }}>
        {headline && <h2>{headline}</h2>}
        {content && <p>{content}</p>}
      </Grid.Column>
    </Grid>
  </div>
)

const Logo = styled.img`
  width: 150px;
  height: 150px;
`
